import html from "./UpdateEmailSurveyContainer.html"
import "../PlatformCompatibilityService.js"
import "../SurveyManager.js"
import "./SurveyModal.js"

var module = angular.module("ResearchKitApplicationModule");

module.component('updateEmailSurveyContainer', {
	template: html,
	bindings: {
		showUpdateEmailSurvey: '<',
		currentEmail: '<',
		participantId: '<'

	},
	controller: 'updateEmailSurveyContainerController',
	controllerAs: 'vm'
});

module.controller('updateEmailSurveyContainerController', ["$scope", "$http", "$cookies", "ceUrl", "platformCompatibilityService", "surveyManagerFactory", "$timeout",
	function ($scope, $http, $cookies, ceUrl, platformCompatibilityService, surveyManagerFactory, $timeout) {
		var vm = this;
		vm.surveyClosed = false;

		function surveyFinished(reason) {
			vm.surveyClosed = true;

			if (vm.participantId) {
				$scope.$emit("updateContactInfoFinished", reason === "Completed");
			} else {
				$scope.$emit("surveyFinished", reason);
				if (reason === "Completed") {
					$scope.$emit("reloadDashboard");
				}
			}

			vm.surveyManager = null;
			vm.platforms = null;
		}

		function checkEmailUpdateCompleteCallback(emailAddress) {
			if (!vm.participantId) {
				var dt = new Date();
				var cookiePath = ceUrl.getRoot() + "identityserver/local";
				$cookies.put('participant-login', emailAddress, { path: cookiePath, expires: new Date(dt.getFullYear() + 1, dt.getMonth(), dt.getDate()) });
			}

			vm.surveyManager.currentStepManager.continue();
		}

		function checkEmailUpdateComplete(targetEmailAddress, callback) {

			var isEmailUpdateCompleteUrl = null;
			if (vm.participantId) {
				isEmailUpdateCompleteUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/isEmailUpdateComplete?targetEmailAddress=' + encodeURIComponent(targetEmailAddress);
			} else {
				isEmailUpdateCompleteUrl = 'api/researchkit/account/isEmailUpdateComplete?targetEmailAddress=' + encodeURIComponent(targetEmailAddress);
			}

			return $http.get(ceUrl.make(isEmailUpdateCompleteUrl)).then(
				function (response) {
					vm.verified = response.data;
					if (vm.surveyClosed) {
						return;
					}
					else if (!vm.verified) {
						$timeout(function () {
							checkEmailUpdateComplete(targetEmailAddress, callback);
						}, 500);
					} else {
						callback();
					}
				});
		}

		function updateEmail(emailAddress) {
			var updateEmailModel = {
				NewEmail: emailAddress
			};

			var beginUpdateEmailUrl = null;
			if (vm.participantId) {
				beginUpdateEmailUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/beginUpdateEmail';
			} else {
				beginUpdateEmailUrl = 'api/researchkit/account/beginUpdateEmail';
			}

			$http.put(ceUrl.make(beginUpdateEmailUrl), updateEmailModel).then(
				function (response) {
					vm.normalizedEmailAddress = response.data.TargetEmailAddress;
					var textTemplate = vm.surveyManager.template.steps[2].text;
					vm.surveyManager.template.steps[2].text = textTemplate.replace("${email}", vm.normalizedEmailAddress);

					vm.surveyManager.currentStepManager.continue();
					checkEmailUpdateComplete(response.data.TargetEmailAddress, function () {
						checkEmailUpdateCompleteCallback(vm.normalizedEmailAddress);
					});
				},
				function (response) {
					alert(response.data);
					vm.surveyManager.currentStepManager.back();
					return;
				});
		}

		function handleWaitForUpdateStep(step) {
			var stepResult = vm.surveyManager.getResult();
			var emailAddress = stepResult.StepResults[0].QuestionResults[0].Answers[0];
			updateEmail(emailAddress);
		}

		$scope.$on("setStep", function (e, step) {
			if (step.identifier === 'WaitForUpdate') handleWaitForUpdateStep(step);
		});

		this.$onChanges = function (changesObj) {
			if (!(changesObj.showUpdateEmailSurvey && changesObj.showUpdateEmailSurvey.currentValue))
				return;

			vm.surveyClosed = false;
			var getAccountUpdateUrl = null;
			if (vm.participantId) {
				getAccountUpdateUrl = 'api/researchkit/administration/participantsupport/' + vm.participantId + '/GetAccountUpdateSurvey?updateContactInfoType=email';
			} else {
				getAccountUpdateUrl = 'api/researchkit/account/GetAccountUpdateSurvey?updateContactInfoType=email';
			}

			$http.get(ceUrl.make(getAccountUpdateUrl)).then(
				function (response) {
					var surveyTemplate = response.data;
					vm.platforms = platformCompatibilityService.getPlatforms(surveyTemplate);

					vm.surveyManager = surveyManagerFactory.createSurveyManager({
						template: surveyTemplate,
						finishedCallback: surveyFinished
					}, {
						mode: "Survey",
						isCoordinatorEntered: false,
						analyticsEnabled: false
					});

					vm.surveyManager.startSurvey();
				},
				function (response) {
					alert(response.data);
					surveyFinished("Error");
					return;
				}
			);
		};
	}]);